import { useEffect } from "react";

/**
 * Auto-clear any truthy value after a delay by invoking the provided clear function.
 */
export default function useAutoClear<T>(
  value: T,
  clear: () => void,
  delay = 4000
) {
  useEffect(() => {
    if (!value) return;
    const t = setTimeout(clear, delay);
    return () => clearTimeout(t);
  }, [value, clear, delay]);
}
